/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandOrder, CommandResource } from '@alfa-client/command-shared';
import { ExpansionPanelWithUserComponent, HistorieItemHeaderComponent } from '@alfa-client/historie-shared-ui';
import { Component, input } from '@angular/core';
import { isEmpty } from 'lodash-es';

@Component({
  selector: 'alfa-historie-item-aktenzeichen',
  templateUrl: './historie-item-aktenzeichen.component.html',
  styleUrls: ['./historie-item-aktenzeichen.component.scss'],
  imports: [ExpansionPanelWithUserComponent, HistorieItemHeaderComponent],
})
export class HistorieItemAktenzeichenComponent {
  readonly command = input.required<CommandResource>();

  get aktenzeichen(): string {
    return this.command().body.aktenzeichen;
  }

  get aktenzeichenDeleted(): boolean {
    return isEmpty(this.aktenzeichen);
  }

  get headline(): string {
    return this.aktenzeichenDeleted ? 'das Aktenzeichen gelöscht.' : HISTORIE_TEXT_BY_KOMMENTAR_ORDER[this.command().order];
  }
}

const HISTORIE_TEXT_BY_KOMMENTAR_ORDER: { [order: string]: string } = {
  [CommandOrder.SET_AKTENZEICHEN]: 'das Aktenzeichen geändert.',
};
